import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
// import Ajv from "ajv";
import { JsonEditor as Editor } from "jsoneditor-react";
import { tx } from "../../lib/ddd/ddd";
import "jsoneditor-react/es/editor.min.css";
import { JSONSchemaFaker } from "json-schema-faker";
import SelectInput from "@mui/material/Select/SelectInput";
import { MenuItem } from "@mui/material";
import { OrgIdContext } from "../../store/orgId_context";
import axios from "axios";
//import "ace-builds/src-noconflict/ace";
// import "ace-builds/src-noconflict/mode-json";
// import "ace-builds/src-noconflict/theme-github";
// import ace from "ace-builds";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

// const ajv = new Ajv({ allErrors: true, verbose: true });

const PlaygroundForm = ({
  schema,
  onJsonChange,
  onSetCurlHandler,
  activeApi,
}) => {
  const [formData, setFormData] = useState(null);
  const { connectionKey, setConnKeyHandler, mainOrgId } =
    useContext(OrgIdContext);

  const editorRef = useRef(null);

  const generateCurlCommand = useCallback(
    (json) => {
      const jsonString = JSON.stringify(json);

      const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.${activeApi} -H "Authorization: IoT ${connectionKey}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`);
      onSetCurlHandler(curlCmd);
    },
    [onSetCurlHandler, activeApi, connectionKey]
  );

  useEffect(() => {
    if (!connectionKey) {
      axios
        .post(
          apiRequestAddress,
          {
            jsonrpc: "2.0",
            method: "Extension.Execute",
            params: {
              extension: "EUeInvoices.GetCurrentTData",
            },
            id: 13,
          },
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res?.data?.result) {
            setConnKeyHandler(res?.data?.result?.Result?.ConnectionKey);
          }
        });
    }
  }, [connectionKey, setConnKeyHandler]);

  const replaceSessionTransformerId = useCallback((obj, replacement) => {
    if (typeof obj === "object" && obj !== null) {
      for (let key in obj) {
        if (obj[key] === "sessionTransformerId") {
          obj[key] = replacement;
        } else {
          replaceSessionTransformerId(obj[key], replacement);
        }
      }
    }
    return obj;
  }, []);

  useEffect(() => {
    if (schema["$d3pro"] && schema["$d3pro"].examples !== undefined) {
      const modifiedData = schema["$d3pro"]?.examples[0][
        "$d3pro"
      ]?.content.replace(/"sessionTransformerId"/g, `"${mainOrgId}"`);
      console.log(modifiedData);
      setFormData(JSON.parse(modifiedData));
      generateCurlCommand(modifiedData);
      onJsonChange(JSON.parse(modifiedData));
      if (editorRef.current !== null) {
        editorRef.current.set(JSON.parse(modifiedData));
      }
    } else {
      JSONSchemaFaker.resolve(schema).then((sample) => {
        setFormData(sample);
        generateCurlCommand(sample);
        onJsonChange(sample);
        if (editorRef.current !== null) {
          editorRef.current.set(sample);
        }
      });
    }
  }, [schema, generateCurlCommand, onJsonChange, mainOrgId]);
useEffect(() => {console.log(formData);},[formData]);
  const setRef = (instance) => {
    if (instance) {
      editorRef.current = instance.jsonEditor;
    } else {
      editorRef.current = null;
    }
  };

  const handleJsonChange = (json) => {
    setFormData(json);
    onJsonChange(json);
    generateCurlCommand(JSON.stringify(json));
  };

  const renderSelect = (prop, value, onChange) => {
    const { enum: enumValues } = prop;

    return (
      <SelectInput value={value} onChange={onChange}>
        {enumValues.map((enumValue) => (
          <MenuItem key={enumValue} value={enumValue}>
            {enumValue}
          </MenuItem>
        ))}
      </SelectInput>
    );
  };

  const customEditorOptions = {
    customEditors: {
      select: {
        schema: {
          type: "string",
        },
        data: {
          render: renderSelect,
        },
      },
    },
  };

  return (
    <>
      {formData && (
        <Editor
          ref={setRef}
          mode="code"
          allowedModes={["code", "tree"]}
          value={formData}
          onChange={handleJsonChange}
          // ajv={ajv}
          schema={schema}
          editorOptions={customEditorOptions}
          // ace={ace}
        />
      )}
      {/* <div>{JSON.stringify(formData)}</div> */}
    </>
  );
};

export default PlaygroundForm;
